import { c as _c } from "react/compiler-runtime";
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { useRouter } from 'next/router';
type RouterQuery = {
  step?: string;
  tab?: FunnelStepSettingTabsEnum;
  funnelId?: string;
  [key: string]: string | string[] | undefined;
};
export function useUpdateFunnelStepQuery() {
  const $ = _c(3);
  const router = useRouter();
  const query = router.query as RouterQuery;
  let t0;
  if ($[0] !== query || $[1] !== router) {
    const updateFunnelStepQuery = (funnelStepId, t1) => {
      const funnelStepTab = t1 === undefined ? FunnelStepSettingTabsEnum.stepConfiguration : t1;
      if (!router.isReady) {
        return;
      }
      const currentStep = query.step ? Number(query.step) : null;
      if (currentStep === funnelStepId && query.tab === funnelStepTab) {
        return;
      }
      const newQuery = {
        ...query,
        step: String(funnelStepId),
        tab: funnelStepTab
      };
      router.replace({
        pathname: router.pathname,
        query: newQuery
      }, undefined, {
        shallow: true
      }).catch(_temp);
    };
    t0 = {
      updateFunnelStepQuery
    };
    $[0] = query;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp(e) {
  if (!e.cancelled) {
    console.error(e);
  }
}